export default __webpack_public_path__ + "static/media/labicon.1e61a105.svg";